module.exports = __webpack_public_path__ + "media/images/icons/filled/mail-d12b86c7595984aa8f73fc0be81220b3.svg";